<template>
	<div class="page-area" @click="$emit('changeModelType', '')" @touch.stop>
		<div class="login-area" @click.stop>
			<div class="title">{{ $t(`text7`) }}</div>
			<div class="form-area">
				<el-form :model="loginForm" :rules="rules" ref="formRef">
					<el-form-item :label="$t(`text14`)" prop="RealName">
						<el-input
							v-model="loginForm.RealName"
							placeholder=""
						></el-input>
					</el-form-item>
					<el-form-item :label="$t(`text15`)" prop="Email">
						<el-input
							v-model="loginForm.Email"
							placeholder=""
						></el-input>
					</el-form-item>
					<el-form-item :label="$t(`text16`)" prop="Password">
						<el-input
							v-model="loginForm.Password"
							placeholder=""
						></el-input>
					</el-form-item>
					<el-form-item :label="$t(`text52`)" prop="confirmPassword">
						<el-input
							v-model="loginForm.confirmPassword"
							placeholder=""
						></el-input>
					</el-form-item>
					<el-form-item :label="$t(`text17`)" prop="PhoneNumber">
						<el-input
							v-model="loginForm.PhoneNumber"
							placeholder=""
						>
						</el-input>
					</el-form-item>
					<el-form-item :label="$t(`text18`)" prop="Code">
						<el-input v-model="loginForm.Code" placeholder="">
							<template slot="append">
								<div
									class="get-code"
									@click="handleSendCode"
									v-if="countDown.time === 60"
								>
									{{ countDown.text }}
								</div>
								<div class="get-code" v-else>
									{{ countDown.text }}
								</div>
							</template>
						</el-input>
					</el-form-item>
				</el-form>
				<div class="btn-area">
					<el-button class="btn" type="primary" @click="submitForm">
						{{ $t(`text7`) }}
					</el-button>
				</div>
			</div>
			<div
				style="text-align: center;"
				@click="$emit('changeModelType', 'login')"
			>
				{{ $t(`text19`) }}
			</div>
		</div>
	</div>
</template>

<script>
import { register, sendRegisterSMS } from "@/api/user";

export default {
	components: {},
	data() {
		return {
			loginForm: {
				RealName: "",
				Email: "",
				Password: "",
				confirmPassword: "",
				PhoneNumber: "",
				Code: "",
			},

			rules: {
				RealName: [
					{
						required: true,
						message: this.$t(`text8`),
					},
				],
				Email: [
					{
						required: true,
						message: this.$t(`text8`),
					},
				],
				Password: [
					{
						required: true,
						message: this.$t(`text8`),
					},
				],
				confirmPassword: [
					{
						required: true,
						message: this.$t(`text8`),
					},
					{
						validator: (rule, value, callback) => {
							if (value !== this.loginForm.Password) {
								callback(new Error(this.$t(`text54`)));
							} else {
								callback();
							}
						},
					},
				],
				PhoneNumber: [
					{
						required: true,
						message: this.$t(`text8`),
					},
				],
				Code: [
					{
						required: true,
						message: this.$t(`text8`),
					},
				],
			},
			countDown: {
				time: 60,
				text: this.$t(`text12`),
			},
		};
	},
	mounted() {},
	methods: {
		submitForm() {
			this.$refs["formRef"].validate(async (valid) => {
				if (valid) {
					let { Code } = await register(this.loginForm);
					if (Code === 200) {
						this.$message({
							message: this.$t(`text20`),
							type: "success",
						});
						this.$emit("changeModelType", "login");
					}
				}
			});
		},
		async handleSendCode() {
			if (this.loginForm.PhoneNumber === "") {
				this.$message({
					message: this.$t(`text11`),
					type: "error",
				});
				return;
			}

			let params = {
				PhoneNumber: this.loginForm.PhoneNumber,
				PicCode: "",
				Sequence: "",
				IsExists: true,
			};
			let { Code } = await sendRegisterSMS(params);
			if (Code === 200) {
				const timer = setInterval(() => {
					this.countDown.time--;
					this.countDown.text = `${this.countDown.time}${this.$t(
						`text13`
					)}`;
					if (this.countDown.time === 0) {
						this.countDown.time = 60;
						this.countDown.text = this.$t(`text12`);
						clearInterval(timer);
					}
				}, 1000);
			}
		},
	},
};
</script>

<style scoped lang="scss">
::v-deep .el-input__inner {
	background-color: #d2dafa;
}
::v-deep .el-form-item {
	margin-bottom: 10px;
}

.page-area {
	position: fixed;
	inset: 0;
	background: rgba($color: #000000, $alpha: 0.5);

	.login-area {
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
		height: 90%;
		padding-bottom: 20px;
		background-color: #fff;
		border-radius: 10px 10px 0 0;
		overflow-y: auto;
		.title {
			padding: 30px 0 0 30px;
			font-size: 18px;
			font-weight: bold;
			color: #135192;
		}
		.form-area {
			padding: 30px;
			.get-code {
				width: 80px;
				text-align: center;
			}
			.btn-area {
				display: flex;
				justify-content: center;
				margin-top: 50px;
				.btn {
					width: 60%;
					margin: 0 auto;
					background-color: #135192;
					border: none;
				}
			}
		}
	}
}
</style>
